import React from 'react';
import logoUniversite from "./../../../assets/img/logo-uss.png";
import "./../layout.css";
import { UserOutlined } from '@ant-design/icons';
import BarreRecherche from '../../buttons/BarreRecherche';
import { useNavigate } from 'react-router-dom';


const TopBar = () => {
    const navigate = useNavigate();

     const handleOpenProfil = () => {
        navigate("/dashboard/profil")
     }

    return (
        <div className='divGlob'>
             <div className="divLogo">
                    <img className="imgSexion" src={logoUniversite} alt="" />
                    <div className='divNomApplication'>
                        <p style={{margin:0, fontSize:13}}><span style={{color:"red"}}>A</span>pplication</p>
                        <p style={{margin:0, fontSize:13}}><span style={{color:"#43CE0C"}}>R</span>ecueil</p>
                        <p style={{margin:0, fontSize:13}}><span style={{color:"#C071DE"}}>D</span>onnées</p>
                    </div>
            </div>

                <div className='divAvatar'>
                     <BarreRecherche type="text" 
                    //  value={searchValue} onChange={(e) => setSearchValue(e.target.value)} 
                     allowClear  />
                    <UserOutlined onClick={handleOpenProfil} style={{color:"#43CE0C", fontSize:20}} />
                </div>
        </div>
    );
};

export default TopBar;


// https://demos.creative-tim.com/soft-ui-dashboard-pro-react/?_ga=2.46344103.1427528819.1721043632-942849641.1721043632#/pages/account/settings